export const  getDivisa = (location) => {
  const mxn = location.pathname.match('mxn') ? location.pathname.match('mxn')[0] : null;
  const usd = location.pathname.match('usd') ? location.pathname.match('usd')[0] : null;
  const result = String(mxn ?? usd)
  return result;
};